import api from '@/utils/ky';
import { useQuery } from '@tanstack/react-query';
import { CheckCircleIcon } from 'lucide-react';
import { useParams } from 'react-router-dom';
import { LoadingFeedback } from '../../components/loading-error';
import {
  BulletList,
  BulletList2,
  FeedbackSection,
} from '../../components/ui/session-feedback';

export function MeetingFeedback() {
  const { meetingId } = useParams();
  const { data: feedback, isLoading }: any = useQuery({
    queryKey: ['meeting-feedback', meetingId],
    queryFn: () =>
      api
        .post('api/meeting/feedback', {
          json: { meetingId },
        })
        .json(),
  });

  if (isLoading) {
    return <LoadingFeedback />;
  }

  return (
    <div className="max-w-4xl mx-auto py-12 px-4">
      <h1 className="text-3xl font-bold mb-8">Meeting Feedback</h1>

      <div className="space-y-6">
        <FeedbackSection title="Overview" icon={CheckCircleIcon}>
          <div className="text-gray-600">{feedback.scenarioOverview}</div>
        </FeedbackSection>

        <FeedbackSection title="Strengths" icon={CheckCircleIcon}>
          <BulletList items={feedback.strengths} />
        </FeedbackSection>

        <FeedbackSection title="Areas for Improvement" icon={CheckCircleIcon}>
          <BulletList items={feedback.areasForImprovement} />
        </FeedbackSection>

        <FeedbackSection title="Next Steps" icon={CheckCircleIcon}>
          <BulletList2 items={feedback.actionableNextSteps} />
        </FeedbackSection>
      </div>
    </div>
  );
}
